<template>
  <div>
    <v-row no-gutters>
      <v-col v-if="getEnableAvatar" class="pt-10" cols="12" align="center">
        <span class="text-h2 font-weight-bold grey--text text--darken-3 ada-ignore-text-size">
          {{ $t("default") }}
        </span>
      </v-col>

      <v-col :cols="getEnableAvatar ? 11 : 12" :class="getEnableAvatar ? 'pt-2' : 'pa-0'">
        <v-card :class="[{ homeBackground: !getEnableAvatar }]" flat>
          <v-row class="fill-height pt-16" align="center" justify="center">
            <v-col :cols="getEnableAvatar ? 12 : 10" align="center">
              <v-row justify="center">
                <v-col
                  align="center"
                  :cols="menu.col"
                  v-for="(page, index) in filteredPages"
                  :key="index"
                  :class="getEnableAvatar ? 'pb-10 pa-0' : 'pb-16 pa-0'"
                >
                  <v-card @click="goto(page)" @keydown.enter.prevent="goto(page)" @keydown.space.prevent="goto(page)"
                    class="menuItem d-flex flex-column align-center justify-center action-card"
                    :width="menu.width"
                    :height="menu.height"
                    elevation="8"
                    :ripple="false"
                  >
                    <v-img
                      :src="page.displayIcon.url"
                      :width="menu.imageWidth"
                      contain
                    >
                    </v-img>
                    <v-card-text class="text-h5 primary--text font-weight-bold">
                      {{ page.pageName }}
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <!-- Payment Popup -->
      <v-dialog
        v-model="getPaymentPopUp"
        max-width="45%"
        @click:outside="showPaymentPopup"
      >
        <v-card class="pa-4 rounded-xl">
    <!-- Header -->
    <div class="d-flex align-start justify-space-between mb-2">
      <div class="flex-grow-1 text-center pl-12 pt-3">
        <span class="text-h3 font-weight-bold grey--text text--darken-3 ada-ignore-text-size ">
          {{ $t("paymentDialogHeader") }}
        </span>
      </div>

      <div
        class="d-flex flex-column align-center justify-center close-btn"
        tabindex="0"
        role="button"
        @click="showPaymentPopup"
        @keydown.enter.prevent="showPaymentPopup"
        @keydown.space.prevent="showPaymentPopup"
      >
        <v-icon size="44" color="red darken-2">
          mdi-close-circle
        </v-icon>
        <span class="red--text caption font-weight-bold text-uppercase mt-1">
          Close
        </span>
      </div>
    </div>
          <v-divider class="mb-8"></v-divider>
          <v-container>
            <v-row
              justify="space-around"
              align="center"
              no-gutters
              class="mb-8 mx-8"
            >
              <v-col
                align="center"
                :cols="5"
                v-for="(page, index) in paymentPages"
                :key="index"
                class="mb-2"
              >
                <v-card
                  @click="goto(page)"
                  class="menuItem d-flex flex-column align-center justify-center rounded-lg frosted"
                  width="350"
                  height="300"
                  max-height="300"
                  elevation="8"

                >
                  <v-img :src="page.displayIcon.url" width="40%" contain>
                  </v-img>
                  <v-card-text class="text-h5 primary--text font-weight-bold">
                    {{ page.pageName }}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-divider v-if="getEnableAvatar"
          class="pb-4"
        ></v-divider>
        <languageBar></languageBar>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import languageBar from "@/components/languageBar";
import { mapGetters } from "vuex";

export default {
  name: "menuMatrix",
  components: {
    languageBar,
  },
  data() {
    return {
      // isPaymentPopupVisible: false,
      menu: {
        height: null,
        width: null,
        col: null,
        imageWidth: null,
      },
      noInternet: ["Maps"],
    };
  },
  computed: {
    ...mapGetters([
      "getCMSlink",
      "getTouchCount",
      "isUserLooking",
      "getAvatarLangCodes",
      "getSessionId",
      "getKioskProfile",
      "getPaymentPopUp",
      "getNetworkConnection",
      "getGreetingStatus",
      "getEnableAvatar",
    ]),

    filteredPages() {
      const CUSTOM_SEQUENCES = { DRO: [12, 3, 2, 10, 1] };
      const locationCode =
        this.getKioskProfile &&
        this.getKioskProfile.data() &&
        this.getKioskProfile.data().locationCode;

      const customOrder = CUSTOM_SEQUENCES[locationCode] || null;

      let orderMap = null;
      if (customOrder) {
        orderMap = new Map(customOrder.map((pos, idx) => [Number(pos), idx]));
      }
      return this.$t("homepages")
        .filter(
          (page) =>
            page.alias !== "payment" ||
            ["payments", "pagos"].includes(page.pageName.toLowerCase())
        )
        .sort((a, b) => {
          // This part of the code now works perfectly for both cases
          if (orderMap) {
            const aPos = orderMap.get(Number(a.displayPosition));
            const bPos = orderMap.get(Number(b.displayPosition));

            const aRank = aPos != null ? aPos : Number.MAX_SAFE_INTEGER;
            const bRank = bPos != null ? bPos : Number.MAX_SAFE_INTEGER;

            if (aRank !== bRank) return aRank - bRank; // custom order first
          }

          // Fallback for non-DRO locations or items not in the custom order
          return a.displayPosition - b.displayPosition;
        });
    },
    paymentPages() {
      return this.$t("homepages").filter(
        (page) =>
          page.alias === "payment" &&
          page.pageName.toLowerCase() !== "payments" &&
          page.alias === "payment" &&
          page.pageName.toLowerCase() !== "pagos"
      );
    },
  },
  methods: {
    goto(page) {
      var date = new Date();
      // To start session using touch - when no face detected
      if (!this.isUserLooking) {
        this.$store.commit("setTouchCount", this.getTouchCount + 1);
        console.log(this.getTouchCount, " this is the touchCount in MM");
        if (this.getTouchCount === 1) {
          this.$store.dispatch("addSessionDataToStrapi", {
            applicationId: this.getKioskProfile.data().applicationId,
            actionType: "Session Started",
            applicationSessionId: this.getSessionId,
            timeStamp: date.toISOString(),
            sessionPayload: {
              module: "Default",
              action: "Touch Detected",
              response: "User Session Started",
              timeStamp: date.toISOString(),
            },
          });
          this.$store.dispatch("addInteractionToPostgres", {
            actionType: "Session Started",
            actionPayload: { recognitionType: "Touch" },
          });
        }
      }

      if (page.pageType.length !== 0) {
        switch (page.pageType[0].__typename) {
          case "ComponentHomepageNavigation":
            this.$store.commit("setRequestQna", false);
            this.$store.commit("setIsThinking", false);
            this.$store.commit("setSpeechRecognitionHandler", false);
            this.$router.push("/" + page.pageType[0].pathName.toLowerCase());
            this.$store.commit("setPageHeader", page.pageType[0].pageHeader);
            this.$store.commit("setQnaKeyword", "");
            // Will be called irrespective of Touch Count
            this.$store.dispatch("addSessionDataToStrapi", {
              applicationId: this.getKioskProfile.data().applicationId,
              actionType: "Touch",
              applicationSessionId: this.getSessionId,
              timeStamp: date.toISOString(),
              sessionPayload: {
                module: "Home Page",
                action: "navigate",
                response: page.pageType[0].pathName,
                timeStamp: date.toISOString(),
              },
            });

            this.$store.dispatch("addInteractionToPostgres", {
              actionType: "Interaction",
              actionPayload: {
                module: "Home Page",
                navigateFrom: "Home Page",
                navigateTo: page.pageType[0].pathName,
                interactionType: "Touch",
                elementContent: page.pageType[0].pathName,
              },
            });
            this.$store.dispatch("avatarTalk", page.speech);
            break;
          case "ComponentHomepageDialogBox":
            console.log("Opening Component Dialog Box : ");

            // To start session using touch - when no face detected

            if (page.pageType[0].type === "url") {
              // if(page.pageType[0].textList === 'https://chesco.maps.arcgis.com/apps/webappviewer/index.html?id=38fdd81ef9884a96be8c6dad38f6ec55'){
              this.$store.dispatch("addSessionDataToStrapi", {
                applicationId: this.getKioskProfile.data().applicationId,
                actionType: "Touch",
                applicationSessionId: this.getSessionId,
                timeStamp: date.toISOString(),
                sessionPayload: {
                  module: `Home Page`,
                  action: "Open URL",
                  response: `${page.pageName}`,
                  timeStamp: date.toISOString(),
                },
              });

              this.$store.dispatch("addInteractionToPostgres", {
                actionType: "Interaction",
                actionPayload: {
                  module: "Payments",
                  navigateFrom: "Home Page",
                  navigateTo: "Home Page",
                  interactionType: "Touch",
                  elementContent: page.alias,
                },
              });

              if (this.getPaymentPopUp) {
                this.showPaymentPopup();
              }
              // window.location.href = page.pageType[0].textList;

              if (this.getNetworkConnection) {
                window.open(page.pageType[0].textList, "_blank");
              } else {
                const featureDisabledMsg =
                  "This feature is currently unavailable due to an internet connectivity issue.";
                // this.$store.dispatch('avatarSpeak', featureDisabledMsg)
                this.$store.commit("setTextBubbleText", featureDisabledMsg);
              }
            } else if (page.pageType[0].type === "textList") {
              console.log("Reached at destination");
              this.showPaymentPopup();
              this.$store.dispatch("avatarTalk", page.speech);
            }

            break;
          default:
            break;
        }
      }
    },

    showPaymentPopup() {
      if (this.getPaymentPopUp) {
        this.$store.commit("setPaymentPopUp", false);
      } else {
        this.$store.commit("setPaymentPopUp", true);
      }

      if (!this.getPaymentPopUp) {
        console.log("popup is visible");
        this.$store.commit("setDefaultBubbleText", true);
        this.$store.commit(
          "setTextBubbleText",
          this.$i18n.t("bubbletextafteraction")
        );
      }
    },
  },
  mounted() {
    if (this.filteredPages.length <= 4) {
      if (!this.getEnableAvatar) {
        this.menu = {
          height: 350,
          width: 400,
          col: 5,
          imageWidth: "60%",
        };
      } else {
        this.menu = {
          height: 270,
          width: 280,
          col: 5,
          imageWidth: "60%",
        };
      }
    } else if (this.filteredPages.length <= 6) {
      console.log("This to use");
      if (!this.getEnableAvatar) {
        this.menu = {
          height: 280,
          width: 350,
          col: 4,
          imageWidth: "40%",
        };
      } else {
        this.menu = {
          height: 260,
          width: 275,
          col: 4,
          imageWidth: "55%",
        };
      }
    } else if (this.filteredPages.length <= 9) {
      this.menu = {
        height: 250,
        width: 300,
        col: 3,
        imageWidth: "60%",
      };
    }
  },
};
</script>

<style>
.menuItem {
  /* border: solid #2c6b87 !important; */
  border-radius: 20px !important;
}

.footer {
  bottom: 0 !important;
}

.homeBackground {
  /* background-image: "../assets/Background.png"; */
  background-image: url("./../assets/Background.png");
  background-size: cover;
  width: 1440px !important;
  height: 850px !important;
}

.frosted {
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  background-color: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.action-card {
  transition: all 0.15s ease;
}

.action-card:focus {
  outline: none;  
}     

.action-card:focus-visible {    
  /* box-shadow: 0 0 0 4px #2563EB; */
  /* background-color: #C4A484; */
  border : 6px solid #C4A484;
} 

</style>
<i18n>
    {
      "en": {
          "default": "How Can I Help You?",
          "paymentDialogHeader": "Payments"
        },
      "es":{
          "default": "¿Le puedo ayudar en algo?",
          "paymentDialogHeader": "Pagos"
        }
    }
  </i18n>
